// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share-container ul[data-v-3b1afd8d]{text-align:center}.share-container ul li[data-v-3b1afd8d]{display:inline}.share-container ul li svg[data-v-3b1afd8d]{max-width:35px;margin:0 5px;width:35px;height:35px}", ""]);
// Exports
module.exports = exports;
